module.exports = __webpack_public_path__ + "resources/img/solution_commerce_img_brand.767afb5af3f293dccb5ae259ee716d55.png";